module.exports = __webpack_public_path__ + "img/DUser.2b16cfde.svg";